import { ModulesLoader } from '@wix/ssr-modules-loader'
import {
	registry,
	createRegistryAPI,
	getComponentsLibraries,
	ILibraryTopology,
	ISiteAssetsRegistryAPI,
	ISiteAssetsModel,
} from '@wix/editor-elements-registry/siteAssets'

export { getComponentsLibraries, ISiteAssetsRegistryAPI, ILibraryTopology }

export type IComponentMappers = ISiteAssetsModel['mapper']
export interface IComponentsRegistrySiteAssets {
	getRegistryAPI: () => ISiteAssetsRegistryAPI
	loadComponentMappers: () => Promise<IComponentMappers>
}

export async function createComponentsRegistrySiteAssets(options: {
	libraries: Array<ILibraryTopology>
	modulesLoader: ModulesLoader
}): Promise<IComponentsRegistrySiteAssets> {
	const { libraries, modulesLoader } = options

	const transport = {
		async fetchLibraryManifest(url: string) {
			const response = await modulesLoader.absoluteUrl<string>(url, {
				shouldUseNodeRequire: false,
			})

			return JSON.parse(response)
		},
		async fetchLibraryRuntime(url: string) {
			return (modulesLoader as ModulesLoader).absoluteUrl<string>(url, {
				shouldUseNodeRequire: false,
			})
		},
		async fetchLibraryHotBundle(url: string) {
			return (modulesLoader as ModulesLoader).absoluteUrl<string>(url, {
				shouldUseNodeRequire: false,
			})
		},
		async fetchComponentsBundle(url: string) {
			const content = (modulesLoader as ModulesLoader).absoluteUrl<string>(url, {
				shouldUseNodeRequire: false,
			})

			return content
		},
	}

	const registryAPI = await createRegistryAPI(registry, {
		transport,
		mode: 'eager',
		libraries,
	})

	return {
		async loadComponentMappers() {
			const models = await registryAPI.loadAllComponents()
			return Object.keys(models)
				.filter((componentType) => models[componentType].mapper)
				.reduce((acc, componentType) => {
					return {
						...acc,
						[componentType]: models[componentType].mapper,
					}
				}, {})
		},

		getRegistryAPI() {
			return registryAPI
		},
	}
}
